import React, { useState } from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Button } from '../ui/button';
import { Plus, Trash2, MessageCircle, Mail, MessagesSquare } from 'lucide-react';

const CHANNELS = [
  { id: 'sms', label: 'SMS', Icon: MessagesSquare, color: '#0e3a3a' },
  { id: 'whatsapp', label: 'WhatsApp', Icon: MessageCircle, color: '#25D366' },
  { id: 'email', label: 'Email', Icon: Mail, color: '#d97757' },
];

export function StepContacts({ contacts, setContacts, channels, setChannels }) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');

  const canAdd = phone.trim().length >= 6 || email.trim().length >= 4;

  const addContact = () => {
    if (!canAdd) return;
    setContacts([...(contacts || []), { name: name.trim() || null, phone: phone.trim() || null, email: email.trim() || null }]);
    setName(''); setPhone(''); setEmail('');
  };

  const removeContact = (idx) => {
    setContacts(contacts.filter((_, i) => i !== idx));
  };

  const toggleChannel = (id) => {
    setChannels(channels.includes(id) ? channels.filter((c) => c !== id) : [...channels, id]);
  };

  return (
    <div className="space-y-5">
      <div>
        <Label className="text-[13px]">Canaux d'invitation</Label>
        <div className="mt-2 flex flex-wrap gap-2">
          {CHANNELS.map(({ id, label, Icon, color }) => {
            const active = channels.includes(id);
            return (
              <button
                key={id}
                type="button"
                onClick={() => toggleChannel(id)}
                className={`inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full border text-[13px] btn-anim ${active ? 'text-white' : 'bg-white text-neutral-700 border-black/10 hover:bg-neutral-50'}`}
                style={active ? { background: color, borderColor: color } : {}}
              >
                <Icon className="w-3.5 h-3.5" /> {label}
              </button>
            );
          })}
        </div>
        <p className="text-[11.5px] text-neutral-500 mt-2">
          Aucun SMS ou email réel n'est envoyé pour l'instant. Les invitations sont enregistrées et l'envoi automatique s'activera dès l'intégration d'un opérateur.
        </p>
      </div>

      <div>
        <Label className="text-[13px]">Ajouter un contact</Label>
        <div className="mt-1.5 grid sm:grid-cols-3 gap-2">
          <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Prénom (facultatif)" className="h-10" />
          <Input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+225 07…" className="h-10" inputMode="tel" />
          <Input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="email@…" className="h-10" inputMode="email" />
        </div>
        <Button type="button" onClick={addContact} disabled={!canAdd} className="mt-2 btn-anim h-9 rounded-full bg-[#1a1d1a] hover:bg-black text-white px-4 text-[13px]">
          <Plus className="w-3.5 h-3.5 mr-1" /> Ajouter à la liste
        </Button>
      </div>

      <div>
        <Label className="text-[13px]">Liste des contacts ({contacts?.length || 0})</Label>
        {(!contacts || contacts.length === 0) ? (
          <div className="mt-2 rounded-xl border border-dashed border-black/10 bg-white/60 p-5 text-center text-[12.5px] text-neutral-500">
            Ajoutez des proches à inviter directement à la publication (facultatif).
          </div>
        ) : (
          <div className="mt-2 space-y-2 max-h-52 overflow-auto no-scrollbar">
            {contacts.map((c, i) => (
              <div key={`${c.phone || ''}${c.email || ''}${i}`} className="flex items-center gap-3 rounded-xl bg-white border border-black/5 px-3 py-2">
                <div className="flex-1 min-w-0 text-[13px]">
                  <div className="font-medium text-neutral-800 truncate">{c.name || c.phone || c.email}</div>
                  <div className="text-[11.5px] text-neutral-500 truncate">
                    {[c.phone, c.email].filter(Boolean).join(' · ')}
                  </div>
                </div>
                <button type="button" onClick={() => removeContact(i)} className="p-1.5 rounded-full text-neutral-400 hover:text-rose-600 hover:bg-rose-50">
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
